import React from 'react';

import { upgrade } from '@/assets/icons';
import { AsaphButton } from '@/components/shared/Button';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './PlanCard.module.scss';

export interface PlanCardProps {
	title: string;
	price: string;
	priceNote?: string;
	upperText?: string;
	lowerText: (string | JSX.Element)[];
	buttonLabel: string;
	betaTag?: boolean;
	comingSoon?: boolean;
	noIcon?: boolean;
	buttonClassName?: string;
	onClick?: () => void;
	disabled?: boolean;
}

export const PlanCard: React.FC<PlanCardProps> = ({
	title,
	price,
	priceNote,
	upperText,
	lowerText,
	buttonLabel,
	betaTag = false,
	comingSoon = false,
	noIcon,
	buttonClassName,
	onClick,
	disabled = false,
}) => {
	const planCardClasses = [
		styles['plan-card'],
		disabled ? styles['plan-card--disabled'] : '',
		comingSoon ? styles['plan-card--coming-soon'] : '',
	];
	return (
		<div className={planCardClasses.join(' ')}>
			<div className={styles['plan-card-header']}>
				<div className={styles['plan-card-header-title']}>
					<div className={styles['plan-card-header-title-value']}>
						{title}
					</div>
					{betaTag && (
						<div className={styles['plan-card-beta-tag']}>BETA</div>
					)}
					{comingSoon && (
						<div className={styles['plan-card-coming-soon-tag']}>COMING SOON</div>
					)}
				</div>
				<div className={styles['plan-card-header-price']}>
					<div className={styles['plan-card-header-price-value']}>
						{price}
					</div>
					{priceNote && (
						<div className={styles['plan-card-header-price-note']}>
							{priceNote}
						</div>
					)}
				</div>
			</div>
			{upperText && (
				<div className={styles['plan-card-upper-text']}>
					<div className={styles['plan-card-upper-text-value']}>
						{upperText}
					</div>
				</div>
			)}
			<div className="vsb-15" />
			<div className={styles['plan-card-lower-text']}>
				{lowerText.map((part, index) => (
					<div key={index}>{part}</div>
				))}
			</div>
			<div className="vsb-20" />
			<AsaphButton
				color="blue"
				label={buttonLabel}
				icon={
					!noIcon &&
					!disabled && (
						<SvgIcon component={upgrade} color="disabled" />
					)
				}
				className={classNames([
					styles['plan-card-button'],
					buttonClassName,
				])}
				onClick={onClick}
				disabled={disabled}
			/>
		</div>
	);
};
